import { create } from 'zustand';

/**
 * Kenar cubugu menu gruplarinin ACIK/KAPALI durumu.
 *
 * KAPALI olanlar saklaniyor, acik olanlar degil. Sebep: varsayilan ACIK.
 * Acik olanlari saklasaydik, menuye sonradan eklenen bir grup (depoda adi
 * gecmedigi icin) KAPALI dogar ve kullanici onu hic gormeden kaybederdi.
 * Kapalilari saklamak yeni gruplarin acik gelmesini garanti eder.
 *
 * Bicim: `kural.navGroups` altinda JSON dizi (`["nav.groupInsights"]`).
 * Tema deposunun aksine burada duz string zorunlulugu YOK — index.html'deki
 * FOUC betigi bu degeri okumuyor, ilk boyamadan once bilinmesi gerekmiyor.
 *
 * localStorage her erisimde try/catch icinde: gizli sekmede ve depolama kapali
 * tarayicida `getItem` ISTISNA FIRLATIR (bkz. theme.ts ayni not). Tercih
 * hatirlanmaz ama menu calisir.
 */

export const NAV_GROUPS_STORAGE_KEY = 'kural.navGroups';

const readStored = (): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(NAV_GROUPS_STORAGE_KEY);
    if (raw === null) return [];
    const parsed: unknown = JSON.parse(raw);
    // Bicimi DOGRULA: elle bozulmus ya da eski surumden kalmis bir deger
    // (nesne, sayi dizisi) `includes` cagrisinda patlamasin.
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((value): value is string => typeof value === 'string');
  } catch {
    return [];
  }
};

const writeStored = (collapsed: string[]): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(NAV_GROUPS_STORAGE_KEY, JSON.stringify(collapsed));
  } catch {
    /* yok sayilir */
  }
};

type NavGroupState = {
  /** KAPALI grup anahtarlari. Burada olmayan her grup ACIKTIR. */
  collapsed: readonly string[];
  isCollapsed: (groupKey: string) => boolean;
  toggle: (groupKey: string) => void;
};

export const useNavGroupStore = create<NavGroupState>((set, get) => ({
  collapsed: readStored(),
  isCollapsed: (groupKey) => get().collapsed.includes(groupKey),
  toggle: (groupKey) => {
    const current = get().collapsed;
    const next = current.includes(groupKey)
      ? current.filter((key) => key !== groupKey)
      : [...current, groupKey];
    writeStored(next);
    set({ collapsed: next });
  },
}));
